/* eslint-disable no-magic-numbers */
import { useContext } from 'react'
import { MySiteContext } from 'providers/mySiteProvider'

export const usePersistPagination = () => {
  const { pagination, setDefaultPaginationState } = useContext(MySiteContext)

  function selectPage(currentPage) {
    setDefaultPaginationState((s) => {
      return { ...s, currentPage }
    })
  }

  function nextPage() {
    if (pagination.currentPage === pagination.totalPages) {
      return
    }
    setDefaultPaginationState((s) => {
      return { ...s, currentPage: s.currentPage + 1 }
    })
  }

  function prevPage() {
    if (pagination.currentPage === 1) {
      return
    }

    setDefaultPaginationState((s) => {
      return { ...s, currentPage: s.currentPage - 1 }
    })
  }

  function nextSection() {
    setDefaultPaginationState((s) => {
      const step = 5
      const targetPage = s.currentPage + step
      const boundedPage = Math.min(targetPage, s.totalPages || targetPage)
      return { ...s, currentPage: boundedPage }
    })
  }

  function prevSection() {
    setDefaultPaginationState((s) => {
      const step = 5
      const targetPage = s.currentPage - step
      const boundedPage = Math.max(1, targetPage)
      return { ...s, currentPage: boundedPage }
    })
  }

  const changeResultsPerPage = (e) => {
    setDefaultPaginationState((s) => {
      return { ...s, resultsPerPage: e.value, currentPage: 1 }
    })
  }

  const setPagination = (data) => {
    setDefaultPaginationState(data)
  }

  return { setPagination, selectPage, nextPage, prevPage, nextSection, prevSection, changeResultsPerPage }
}


